import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { LenderUserCallState } from 'app/models/dto/lender-user-call-state';
import { PusherService } from 'app/modules/shared/services/pusher.service';
import { AdminPhoneToolsService } from 'app/services/admin-phone-tools/admin-phone-tools.service';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PushCallAlert } from '../call/call.actions';
import { ClearTeamActiveCalls, GetTeamActiveCalls, SubscribeToTeamActiveCalls } from './admin-phone-tools.actions';
import { Injectable } from '@angular/core';

export class AdminPhoneToolsModel {
    lenderUserCallStates: LenderUserCallState[];
    processing: boolean;
}

@State<AdminPhoneToolsModel>({
    name: 'adminPhoneTools',
    defaults: {
        lenderUserCallStates: [],
        processing: false,
    }
})

@Injectable()

export class AdminPhoneToolsState {

    @Selector()
    static lenderUserCallStates(state: AdminPhoneToolsModel) {
        return state.lenderUserCallStates;
    }

    @Selector()
    static processing(state: AdminPhoneToolsModel) {
        return state.processing;
    }

    constructor(
        private adminPhoneToolsService: AdminPhoneToolsService,
        private pusherService: PusherService,
        private store: Store
    ) {}

    @Action(GetTeamActiveCalls)
    getTeamActiveCalls({ patchState }: StateContext<AdminPhoneToolsModel>, {}: GetTeamActiveCalls) {
        patchState({ processing: true });
        this.adminPhoneToolsService.getTeamActiveCalls().pipe(
            catchError(err => {
                const errorText = err.message ?? 'Initiating Team Call Activity failed.';
                this.store.dispatch(new PushCallAlert('error', errorText));
                return of();
            }), tap((lenderUserCallStates: LenderUserCallState[]) => {
              if(lenderUserCallStates) {
                patchState({ processing: false, lenderUserCallStates: lenderUserCallStates });
              }
            })
        ).subscribe();
    }

    @Action(ClearTeamActiveCalls)
    clearTeamActiveCalls({ patchState }: StateContext<AdminPhoneToolsModel>, { teamId }: ClearTeamActiveCalls) {
        this.pusherUnsubscribe(teamId);
        patchState({ lenderUserCallStates: [] });
    }

    @Action(SubscribeToTeamActiveCalls)
    subscribeToBorrowerMessages({ getState }: StateContext<AdminPhoneToolsModel>, { teamId }: SubscribeToTeamActiveCalls) {
        const currentState = getState();
        this.pusherSubscribe(teamId);
        if (!(currentState.lenderUserCallStates.length > 0)) {
            this.store.dispatch(new GetTeamActiveCalls());
        }
    }

    pusherSubscribe(teamId: number) {
        const cxTeams = [1281, 2099];
        if (cxTeams.includes(teamId)) {
            this.pusherService
                .subscribe('active-calls-team-customer-service')
                .bind_global(this.handlePusherEvent.bind(this));
        } else {
            this.pusherService
                .subscribe(`active-calls-team-${teamId}`)
                .bind_global(this.handlePusherEvent.bind(this));
        }
    }

    handlePusherEvent(eventName: string) {
        if (eventName.startsWith('team-active-calls-')) {
            this.store.dispatch(new GetTeamActiveCalls());
        }
    }

    pusherUnsubscribe(teamId: number) {
        const cxTeams = [1281, 2099];
        if (cxTeams.includes(teamId)) {
            this.pusherService.unsubscribe('active-calls-team-customer-service');
        } else {
            this.pusherService.unsubscribe(`active-calls-team-${teamId}`);
        }
    }

}
